<template>
  <div>
    <section class="my-30" v-if="getEnableWalkScore">
      <Container>
        <SectionHeader>Walk score</SectionHeader>
        <div>
          <HMTWalkScoreFrame />
        </div>
      </Container>
    </section>
    <section class="my-30" v-if="getEnableHoodq">
      <Container>
        <SectionHeader>HoodQ</SectionHeader>
        <div>
          <HMTHoodQ></HMTHoodQ>
        </div>
      </Container>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import HMTWalkScoreFrame from '@/shared/components/WalkScoreFrame';
  import HMTHoodQ from '@/shared/components/HoodQ';
  import Container from '../../components/Container';

  export default {
    name: 'WalkScore',
    components: {
      SectionHeader,
      HMTWalkScoreFrame,
      HMTHoodQ,
      Container
    },
    computed: {
      ...mapGetters('tour', ['getEnableWalkScore', 'getEnableHoodq'])
    }
  };
</script>
